import React, {useState} from "react";
import {
    AmortizationEntryList,
    AmortizationEntryRestControllerApiFactory,
    AmortizationRestControllerApiFactory,
} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {fmtAmt} from "../../../../components/utils/numbers";
import {FormButtonProps} from "../../../../components/form/form_inputs/form_button";
import {useNavigate} from "react-router-dom";
import {SoftChip} from "../../../../components/kit";

const MONTHS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

export const AmortizationListPage = () => {
    const apiManager = useApiManager();
    const navigate = useNavigate();
    const now = new Date();
    const [generating, setGenerating] = useState(false);
    const [trigger, setTrigger] = useState(0);

    const handleGenerate = (year: number, month: number) => {
        const ctrl = apiManager.factory(AmortizationRestControllerApiFactory);
        setGenerating(true);
        apiManager.execute(ctrl.generate(year, month), `Amortizaciones ${MONTHS[month - 1]} ${year} generadas`)
            .then(() => setTrigger(t => t + 1))
            .finally(() => setGenerating(false));
    };

    const listConfig: AppListConfig<AmortizationEntryList> = {
        title: "Amortizaciones del ejercicio",
        onClick: (bean) => {
            if (bean.fixedAsset?.id) {
                navigate(`/app/admin/accounting/fixed-asset/${bean.fixedAsset.id}`);
            }
        },
        headers: [
            {title: "Activo"},
            {title: "Período", width: 120},
            {title: "Año", width: 60},
            {title: "Mes", width: 60},
            {title: "Dotación", align: "right", width: 110},
            {title: "Amort. acumulada", align: "right", width: 130},
            {title: "Asiento", width: 90},
        ],
        actions: [
            {
                label: generating ? "Generando..." : `Generar ${MONTHS[now.getMonth()]} ${now.getFullYear()}`,
                action: () => handleGenerate(now.getFullYear(), now.getMonth() + 1),
            } as FormButtonProps,
        ],
        decorator: (bean: AmortizationEntryList) => (
            <>
                <TableCell>{bean.fixedAsset?.name}</TableCell>
                <TableCell>{bean.period?.name}</TableCell>
                <TableCell>{bean.year}</TableCell>
                <TableCell>{MONTHS[(bean.month ?? 1) - 1]}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums", fontWeight: 600}}>{fmtAmt(bean.dotationAmount)}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>{fmtAmt(bean.accumulatedAmortization) || "-"}</TableCell>
                <TableCell>
                    {bean.journalEntry?.entryNumber
                        ? <SoftChip tone="success" label={bean.journalEntry.entryNumber}/>
                        : <SoftChip tone="neutral" label="Sin asiento"/>}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(AmortizationEntryRestControllerApiFactory);
            return ctrl.pageAmortizationEntry(currentPage, size, undefined, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig} trigger={trigger} appendable={false}/>;
};
